<template>
    <div class="board-view">
        <div class="board-view__tit">
            <h3 class="title01">{{articleInfo.title}}</h3>
            <div class="board-view__tit__right">
                <span class="date">{{$commonUtils.timestampToDate(articleInfo.createdDt)}}</span>
                <!-- <a href="javascript:;" class="heart active"></a> -->
            </div>
        </div>
        <div class="board-view__cont">
            <div class="board-view__medical-info" v-if="articleInfo.refDoctorList">
                <h4 class="title02">의료진</h4>
                <kr_DoctorCard :doctorList="articleInfo.refDoctorList"/>
            </div>
            <div class="board-view__medical-info" v-if="articleInfo.item1">
                <h4 class="title02">교직원</h4>
                <p>{{articleInfo.item1}}</p>
            </div>
            <div class="board-view__medical-info">
                <h4 class="title02">내용</h4>
                <p v-html="articleInfo.content"></p>
            </div>
        </div>
        <kr_ArticleNavigation :articleInfo="articleInfo"/>
    </div>
    <div class="botton-wrap">
        <router-link :to="$route.path.replace('/view', '/list')" class="sub-button c-gray">목록</router-link>
    </div>
</template>

<script>
export default {
    components: { 

    },
    data() {
        return {
            boardNo: this.$route.query.boardNo || '',
            articleNo: this.$route.query.articleNo || '',
            articleInfo: '',
            attachList: '',
            boardId: this.$route.params.boardId,
            info: null,
        };
    },
    watch: {
        $route(to, from) {
            for (let i in this.$route.query) {
                this[i] = this.$route.query[i];
            }
            this.getView();
        }
    },
    computed: {
        checkAttach() {
            if (this.articleInfo.attachBag) {
                if (this.articleInfo.attachBag.attach != null) {
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        getView() {
            this.axios
                .get(this.api.article.view + this.boardNo + '/' + this.articleNo, {
                    params: {
                        hospId: this.$store.getters.getHost,
                        articleNo: this.articleNo,
                        boardNo: this.boardNo,
                        item18: 'O'
                    }
                })
                .then((res) => {
                    this.articleInfo = res.data;
                    this.attachList = res.data.attachBag.attach;

                    this.info = {
                        favoYn: res.data.favoInfoYn === 'Y' ? 'Y' : 'N',
                        no: this.articleNo,
                        type: 'BBS',
                        mypageYn: 'N'
                    };
                });
        },
    },
    mounted() {
        this.getView();
    }
};
</script>

<style scoped></style>
